export function getCsrfToken(): string | null {
  if (typeof document === "undefined") {
    return null;
  }

  const cookieName = "csrftoken";
  const cookies = document.cookie.split(";");

  for (const cookie of cookies) {
    const parts = cookie.trim().split("=");
    const name = parts[0];
    const value = parts[1];

    if (name === cookieName && value !== undefined) {
      return decodeURIComponent(value);
    }
  }

  return null;
}
